import $ from "jquery"
import "jquery.cookie"
import { urlHelper } from "@/components/mixins/urlHelper"
import {
  DataUtil,
  PartListService,
  UserService,
  WarehouseShippingOptionsService,
  UserSettingsService,
  PartsStoreOrdersService,
  ErrorLogService,
  CacheService
} from "@/services"
import { constants } from "@/const"
import router from "@/router"

const state = {
  user: {},
  availableDealerCodes: [],
  audienceAndExclusions: undefined,
  brandAuth: undefined,
  regionAuth: undefined,
  manualsUrl: undefined,
  isUserUpdating: false,
  partsLists: [],
  isPriceVisible: (typeof $.cookie("showPrice")) === "undefined" || $.cookie("showPrice") === "true",
  facingWarehouse: undefined,
  globalRequestId: DataUtil.newGuid(),
  userSettings: [],
  collapseAllPartDescriptionsValue: false,
  partSearchDefaultSortValue: "",
  gridViewDefaultValue: false,
  tmsCompactViewDefault: false,
  partStoreOrderTotal: undefined,
  isMobile: false,
}

const USER_SETTINGS_CACHE_KEY = 'userSettings';
const USER_SETTINGS_CACHE_MINUTES = 30; // 30 minutes

const getters = {
  user: state => state.user,
  hasPermission: state => permissionName => {
    if (state.user.UserPermissions != undefined) {
      return state.user.UserPermissions.includes(permissionName)
    }
    return false
  },
  canSeeAnyPrice: (state, getters) => {
    return (getters.hasPermission("CanSeeOemList")
      || getters.hasPermission("CanSeeFleetList")
      || getters.hasPermission("CanSeeDealerNet")
      || getters.hasPermission("CanSeeContractPrice")
    )
  },
  canSeeOemList: (state, getters) => {
    return getters.hasPermission("CanSeeOemList");
  },
  canSeeFleetList: (state, getters) => {
    return getters.hasPermission("CanSeeFleetList");
  },
  canPlaceOrders: (state, getters) => {
    return getters.hasPermission("CanPlaceOrders");
  },
  canViewQuickOrder: (state, getters) => {
    return getters.hasPermission("CanViewQuickOrder");
  },
  canSeeContractPrice: (state, getters) => {
    return getters.hasPermission("CanSeeContractPrice");
  },
  canSeeDealerNet: (state, getters) => {
    return getters.hasPermission("CanSeeDealerNet");
  },
  isUserUpdating: state => state.isUserUpdating,
  partsLists: state => state.partsLists,
  isPriceVisible: function () {
    return state.isPriceVisible
  },
  audienceAndExclusions: state => {
    return state.audienceAndExclusions;
  },
  audienceIds: state => {
    return state.audienceAndExclusions ? state.audienceAndExclusions.AudienceIds : null;
  },
  activeAccountId: state => {
    let currentDealerCode = $.grep(state.availableDealerCodes, function (availableDealerCode, i) {
      return availableDealerCode.DealerCodes.split(",").map(x => x.trim()).includes(state.user.DealerCode);
    })
    return currentDealerCode[0].AccountId;
  },
  activeDealer: state => {
    let currentDealerCode = $.grep(state.availableDealerCodes, function (availableDealerCode, i) {
      return availableDealerCode.DealerCodes.split(",").map(x => x.trim()).includes(state.user.DealerCode);
    })
    return currentDealerCode[0];
  },
  billingCurrencyCode: state => {
    let currentDealerCode = $.grep(state.availableDealerCodes, function (availableDealerCode, i) {
      return (availableDealerCode.DealerCodes.includes(state.user.DealerCode))
    })
    return currentDealerCode[0].BillingCurrencyCode
  },
  availableDealerCodes: state => {
    return state.availableDealerCodes
  },
  brandAuth: state => {
    return state.brandAuth
  },
  regionAuth: state => {
    return state.regionAuth
  },
  manualsUrl: state => {
    return state.manualsUrl
  },
  facingWarehouse: state => {
    return state.facingWarehouse
  },
  globalRequestId: state => {
    return state.globalRequestId;
  },
  userSettings: state => {
    return state.userSettings;
  },
  collapseAllPartDescriptions: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.COLLAPSE_ALL_PART_DESCRIPTIONS);
    return setting;
  },
  collapseAllPartDescriptionsValue: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.COLLAPSE_ALL_PART_DESCRIPTIONS);
    return setting.SettingValue;
  },

  partSearchDefaultSort: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.PART_SEARCH_RESULT_DEFAULT_SORT)
    return setting;
  },

  partSearchDefaultSortValue: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.PART_SEARCH_RESULT_DEFAULT_SORT)
    return setting.SettingValue;
  },

  gridViewDefault: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.GRID_VIEW_DEFAULT)
    return setting;
  },

  gridViewDefaultValue: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.GRID_VIEW_DEFAULT)
    return setting.SettingValue;
  },

  tmsCompactViewDefault: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.TMS_COMPACT_VIEW_DEFAULT)
    return setting;
  },

  tmsCompactViewDefaultValue: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.TMS_COMPACT_VIEW_DEFAULT)
    return setting.SettingValue;
  },

  showSideCart: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.SHOW_SIDE_CART)
    return setting;
  },

  showSideCartValue: state => {
    let setting = GetUserSetting(constants.USER_SETTINGS.SHOW_SIDE_CART)
    return setting.SettingValue;
  },

  partStoreOrderTotal: state => {
    return state.partStoreOrderTotal;
  },

  isMobile: state => {
    return state.isMobile;
  }
}

const mutations = {
  SET_USER: function (state, user) {
    state.user = user
  },
  SET_AVAILABLE_DEALER_CODES: function (state, availableDealerCodes) {
    state.availableDealerCodes = availableDealerCodes
  },
  SET_BRAND_AUTH: function (state, brandAuth) {
    state.brandAuth = brandAuth
  },
  SET_REGION_AUTH: function (state, regionAuth) {
    state.regionAuth = regionAuth === 0 ? constants.MAX_AUTH_MASK : regionAuth
  },
  SET_MANUALS_URL: function (state, manualsUrl) {
    state.manualsUrl = manualsUrl
  },
  SET_PARTS_LISTS: function (state, partsLists) {
    state.partsLists = partsLists
  },
  SET_PRICE_VISIBILITY: function (state, isPriceVisible) {
    state.isPriceVisible = isPriceVisible
  },
  SET_AUDIENCE_AND_EXCLUSIONS: function (state, audienceAndExclusions) {
    state.audienceAndExclusions = audienceAndExclusions
  },
  SET_USER_IS_UPDATING: function (state, isUpdating) {
    state.isUserUpdating = isUpdating
  },
  SET_FACING_WAREHOUSE: function (state, facingWarehouse) {
    state.facingWarehouse = facingWarehouse
  },
  SET_GLOBAL_REQUEST_ID: function (state, globalRequestId) {
    state.globalRequestId = globalRequestId
  },
  SET_USER_SETTINGS: function (state, userSettings) {
    state.userSettings = userSettings;
    CacheService.set(USER_SETTINGS_CACHE_KEY, userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  SET_USER_SETTINGS_TMS: function (state, userSettings) {
    state.userSettings = userSettings;
    CacheService.set(USER_SETTINGS_CACHE_KEY, userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  ADD_USER_SETTINGS: function (state, newUserSettings) {
    state.userSettings.push(newUserSettings);
    CacheService.set(USER_SETTINGS_CACHE_KEY, state.userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  SET_COLLAPSE_ALL_PART_DESCRIPTIONS: async function (state, collapseAllPartDescriptions) {
    let userSetting = GetUserSetting(constants.USER_SETTINGS.COLLAPSE_ALL_PART_DESCRIPTIONS);
    userSetting.SettingValue = collapseAllPartDescriptions;
    state.collapseAllPartDescriptionsValue = collapseAllPartDescriptions;
  },
  SET_PART_SEARCH_DEFAULT_SORT: async function (state, partSearchDefaultSort) {
    let userSetting = GetUserSetting(constants.USER_SETTINGS.PART_SEARCH_RESULT_DEFAULT_SORT);
    userSetting.SettingValue = partSearchDefaultSort;
    state.partSearchDefaultSortValue = partSearchDefaultSort;
  },
  SET_GRID_VIEW_DEFAULT: async function (state, gridViewDefault) {
    SetUserSetting(constants.USER_SETTINGS.GRID_VIEW_DEFAULT.Name, gridViewDefault);
    CacheService.set(USER_SETTINGS_CACHE_KEY, state.userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  SET_TMS_COMPACT_VIEW: async function (state, tmsCompactViewDefault) {
    SetUserSetting(constants.USER_SETTINGS.TMS_COMPACT_VIEW_DEFAULT.Name, tmsCompactViewDefault);
    CacheService.set(USER_SETTINGS_CACHE_KEY, state.userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  SET_SHOW_SIDE_CART: async function (state, showSideCart) {
    SetUserSetting(constants.USER_SETTINGS.SHOW_SIDE_CART.Name, showSideCart);
    CacheService.set(USER_SETTINGS_CACHE_KEY, state.userSettings, USER_SETTINGS_CACHE_MINUTES);
  },
  SET_PARTS_STORE_ORDER_COUNT: function (state, partStoreOrderTotal) {
    state.partStoreOrderTotal = partStoreOrderTotal;
  },
  SET_IS_MOBILE: function (state, isMobile) {
    state.isMobile = isMobile;
  }
}

const actions = {
  LOGOUT: ({ commit, dispatch }) => {
    window.location.href = `${window.appGlobals.API_URL}logout`;
  },
  LOAD_USER_DATA: async ({ commit, dispatch }) => {
    await UserService.GetUser().then(result => {
      state.user = result.data;
    });

  },
  REFRESH_PAGE: ({ commit, dispatch }) => {
    router.push(router.currentRoute.fullPath + "#_");
  },
  LOAD_PARTS_LISTS: ({ commit, dispatch }) => {
    const params = {
      accountId: getters.activeAccountId(state),
      userId: state.user.UserId,
      numberItemsToReturn: 10
    };
    PartListService.GetPartListSummary(params).then(result => {
      commit("SET_PARTS_LISTS", result)
    }).catch(err => {
      ErrorLogService.LogException(err)
    })
  },
  UPDATE_DEALER_CODE: ({ commit, dispatch }, params) => {

    var dealerCode = params.dealerCode;
    var isDn6 = params.isDn6;
    var sessionVarString = params.sessionVarString;
    var refreshAfterProcessing = params.refreshAfterProcessing;
    // Clear out some store values before switching dealer codes
    commit("SET_USER_IS_UPDATING", true)
    commit("SET_PARTS_LISTS", [])
    commit("SET_PARTS_STORE_ORDER_COUNT", undefined)

    return UserService.UpdateActiveDealerCode(dealerCode, state.user.DealerRange, state.user.UserId).then(userDtoResponse => {
      if (userDtoResponse.data) {
        commit("SET_USER", userDtoResponse.data);
        GetPartsStoreOrderTotal();
        dispatch("LOAD_AUDIENCE_AND_EXCLUSIONS");
        dispatch("LOAD_ACCOUNT_AND_BRAND_AUTH_AND_REGION_AUTH").then(() => {
          if (refreshAfterProcessing) {
            dispatch("REFRESH_PAGE");
          }
        });
        commit("pushTimedMessage", { header: "Dealer Code updated successfully.", IsError: false, seconds: 5 })
      } else {
        commit("pushTimedMessage", { header: "Unable to update Dealer Code", IsError: true, seconds: 5 })
      }
      commit("SET_USER_IS_UPDATING", false)


      return new Promise(function (resolve, reject) {
        resolve(true)
      })
    })
  },
  LOAD_AUDIENCE_AND_EXCLUSIONS: async ({ commit, dispatch }) => {
    await UserService.GetAudienceAndExclusions(getters.activeAccountId(state), state.user.UserId).then(audienceAndExclusions => {
      commit("SET_AUDIENCE_AND_EXCLUSIONS", audienceAndExclusions.data)
    })
  },

  LOAD_USER_AND_AVAILABLE_ACCOUNTS: async ({ commit, dispatch }) => {
    await UserService.GetUserAndAvailableAccounts(window.appGlobals.SITE_KEY).then(userAndAccounts => {
      commit("SET_USER", userAndAccounts.data.User);
      commit("SET_AVAILABLE_DEALER_CODES", userAndAccounts.data.DealerAuth.AvailableDealerCodes);
      commit("SET_BRAND_AUTH", userAndAccounts.data.DealerAuth.BrandAuth)
      commit("SET_REGION_AUTH", userAndAccounts.data.DealerAuth.RegionAuth)
      commit("SET_MANUALS_URL", userAndAccounts.data.DealerAuth.ManualsUrl)
    });
  },

  LOAD_ACCOUNT_AND_BRAND_AUTH_AND_REGION_AUTH: async ({ commit, dispatch }) => {
    if (state.user.DealerRange == undefined) {
      // state isn't ready yet
      return
    }
    await UserService.GetAvailableAccountsAndBrandAuth(state.user.DealerCode, state.user.UserId, state.user.DealerRange).then(accountsAndBrandAuth => {
      commit("SET_AVAILABLE_DEALER_CODES", accountsAndBrandAuth.data.AvailableDealerCodes)
      commit("SET_BRAND_AUTH", accountsAndBrandAuth.data.BrandAuth)
      commit("SET_REGION_AUTH", accountsAndBrandAuth.data.RegionAuth)
      commit("SET_MANUALS_URL", accountsAndBrandAuth.data.ManualsUrl)
    })
  },
  SET_PRICE_VISIBILITY: ({ commit, dispatch }, isPriceVisible) => {
    $.cookie("showPrice", isPriceVisible, { path: "/" })
    commit("SET_PRICE_VISIBILITY", $.cookie("showPrice") === "true")
    commit("pushTimedMessage", { header: "Price visibility set successfully.", IsError: false, seconds: 5 })
    return new Promise((resolve) => {
      resolve(true)
    })
  },
  LOAD_FACING_WAREHOUSE: async ({ commit, dispatch }) => {
    await WarehouseShippingOptionsService.LoadFacingWarehouse(getters.activeAccountId(state), state.user.UserId)
      .then(facingWarehouseDto => {
        commit("SET_FACING_WAREHOUSE", facingWarehouseDto);
      })
  },
  LOAD_USER_SETTINGS: async ({ commit, dispatch }) => {
    const cached = CacheService.get(USER_SETTINGS_CACHE_KEY, USER_SETTINGS_CACHE_MINUTES);
    if (cached) {
      commit("SET_USER_SETTINGS", cached);
      return;
    }
    await UserSettingsService.GetUserSettings(state.user.UserId)
      .then(userSettings => {
        commit("SET_USER_SETTINGS", userSettings);
        CacheService.set(USER_SETTINGS_CACHE_KEY, userSettings, USER_SETTINGS_CACHE_MINUTES);
      });
  },
  GET_PARTS_STORE_ORDER_TOTAL: async ({ commit, dispatch }) => {
    GetPartsStoreOrderTotal();
  }
}


function GetUserSetting(userSettingConstant) {
  let defaultResponse = {
    UserId: state.user.UserId,
    SettingName: userSettingConstant.Name,
    SettingValue: userSettingConstant.DefaultValue
  }

  if (state.userSettings === "") {
    state.userSettings = [defaultResponse]
    return defaultResponse
  }

  let setting = state.userSettings.find(x => x.SettingName === userSettingConstant.Name);
  if (setting === undefined) {
    state.userSettings.push(defaultResponse)
    return defaultResponse
  }

  return setting;
}

function SetUserSetting(settingName, value) {
  let setting = state.userSettings.find(x => x.SettingName === settingName);
  if (setting) {
    setting.SettingValue = value;
  } else {
    state.userSettings.push({
      UserId: state.user.UserId,
      SettingName: settingName,
      SettingValue: value
    });
  }
  CacheService.set(USER_SETTINGS_CACHE_KEY, state.userSettings, USER_SETTINGS_CACHE_MINUTES);
  UserSettingsService.SaveUserSettings(state.userSettings);
}

function GetPartsStoreOrderTotal() {
  let accountCodes = [state.user.DealerCode];
  let orderStatus = [1]; // maps to "Submitted" in SaiTypes

  let partsStoreOrderCountRequest = {
    "AccountId": state.user.PrimaryAccountId,
    "UserId": state.user.UserId,
    "AccountCodes": accountCodes,
    "OrderStatus": orderStatus,
    "StartDate": undefined,
    "EndDate": undefined
  }

  return PartsStoreOrdersService.GetOrderCount(
    partsStoreOrderCountRequest
  ).then(orderCount => {
    state.partStoreOrderTotal = orderCount.data;
  }).catch(err => {
    ErrorLogService.LogException(err)
    return false;
  })
}

export default {
  getters,
  mutations,
  actions,
  state
}
